import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import { blogData } from "../Data/blogs";
import { Helmet } from "react-helmet"; // Import Helmet
import { websiteTitle, websiteURL } from "../helper/constants";
import NavbarBlogs from "../components/NavbarBlogs"; // Import your Navbar component
import Footer from "../components/Footer"; // Import your Footer component

export default function BlogList() {
  useEffect(() => {
    // Scroll to top when the page is rendered
    window.scrollTo(0, 0);
  }, []);

  return (
    <>
      <NavbarBlogs blogs={false} />
      <section className="container mx-auto py-16">
        <h1 className="text-2xl font-semibold text-center mb-6">All Blogs</h1>
        <div className="grid grid-cols-1 lg:grid-cols-3 md:grid-cols-2 gap-6">
          {blogData.map((blog, index) => (
            <div key={index} className="p-1 rounded-lg border border-inherit dark:border-gray-700 m-2">
              <Helmet>
                <title>{blog.title} - {websiteTitle}</title>
                <meta name="description" content={blog.desc} />
                <meta property="og:title" content={blog.title} />
                <meta property="og:description" content={blog.desc} />
                <meta property="og:image" content={blog.image} />
                <meta property="og:url" content={`${websiteURL}/blogs/${blog.slug}`} />
                <script type="application/ld+json">
                  {JSON.stringify({
                    "@context": "https://schema.org",
                    "@type": "BlogPosting",
                    headline: blog.title,
                    description: blog.desc,
                    image: blog.image,
                    author: {
                      "@type": "Person",
                      name: blog.author,
                    },
                    datePublished: blog.date,
                    url: `${websiteURL}/blogs/${blog.slug}`,
                  })}
                </script>
              </Helmet>

              <img
                src={blog.image}
                alt={blog.title}
                className="w-full h-48 object-cover rounded"
              />
              <Link
                to={`/blogs/${blog.slug}`}
                className="text-[17px] mt-2 mb-2 font-medium h5 hover:text-amber-500 dark:text-white dark:hover:text-amber-500 transition duration-500 ease-in-out block"
              >
                {blog.title}
              </Link>
              <p className="text-sm text-gray-600">
                {blog.desc.length > 85 ? blog.desc.slice(0, 85) + "..." : blog.desc}
              </p>
              <Link to={`/blogs/${blog.slug}`} className="text-amber-500 mt-2 block">
                Read More
              </Link>
            </div>
          ))}
        </div>

        {/* Structured Data */}
        <Helmet>
          <script type="application/ld+json">
            {JSON.stringify({
              "@context": "https://schema.org",
              "@type": "Blog",
              "headline": "All Blogs - Your Website",
              "description": "Browse through all our latest blog posts on various topics.",
              "mainEntityOfPage": `${websiteURL}/blogs`, // Change with your URL
              "url": `${websiteURL}/blogs`, // Change with your URL
            })}
          </script>
        </Helmet>
      </section>
      <Footer />
    </>
  );
}
